import React, { useState, useEffect } from "react";
import { Box, Button, Menu, MenuItem, AppBar, Toolbar, IconButton, useTheme, useMediaQuery, Typography } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { tokens } from "../../theme";
import SettingsIcon from "@mui/icons-material/Settings";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import TimelineOutlinedIcon from "@mui/icons-material/TimelineOutlined";
import StorageIcon from '@mui/icons-material/Storage';
import LogoutIcon from "@mui/icons-material/Logout";
import PersonIcon from "@mui/icons-material/Person";
import profileImage from "../../assets/Login/tico.ico"; // Ensure this is the correct path for your company logo
import MonitorHeartOutlinedIcon from "@mui/icons-material/MonitorHeartOutlined";

const Topbar = ({ setIsAuthenticated }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // Check if screen width is small

  const [consultaAnchorEl, setConsultaAnchorEl] = useState(null);
  const [graficaAnchorEl, setGraficaAnchorEl] = useState(null);
  const [settingsAnchorEl, setSettingsAnchorEl] = useState(null);
  const [profileAnchorEl, setProfileAnchorEl] = useState(null);
  
  // States for managing user info
  const [fullname, setFullname] = useState('');
  const [depa, setDepa] = useState('');


  useEffect(() => {
    // Retrieve user info from localStorage
    const storedFullname = localStorage.getItem('userFullname');
    const storedDepa = localStorage.getItem('userDepa');

    setFullname(storedFullname || '');
    setDepa(storedDepa || '');
}, []);


//CAMBIO: Aseguramos que esta función esté definida y sea accesible.
const handleMenuOpen = (setAnchorEl) => (event) => {
  setAnchorEl(event.currentTarget);
};

const handleMenuClose = (setAnchorEl) => () => {
  setAnchorEl(null);
};

  const handleLogout = () => {
    localStorage.removeItem("userToken");
    setIsAuthenticated(false);
    setSettingsAnchorEl(null);
    navigate("/");
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        backgroundColor: "#771726", // 🎨 Cambio: Color de fondo según la paleta de Grupo TECSIR
        zIndex: 1300,
      }}
    >
      <Toolbar sx={{ minHeight: 56 }}>
        {/* Company Logo */}
        <Box sx={{ marginRight: 1 }}>
          <img
            src={profileImage} // Your company logo
            alt="Company Logo"
            style={{ width: 40, height: 40 }} // Adjust size as needed
          />
        </Box>

        {isMobile ? (
          <>
            <IconButton component={Link} to="/" sx={{ color: "white" }}>
              <HomeOutlinedIcon />
            </IconButton>
            <IconButton sx={{ color: "white" }} onClick={handleMenuOpen(setConsultaAnchorEl)}>
              <StorageIcon />
            </IconButton>
            <IconButton sx={{ color: "white" }} onClick={handleMenuOpen(setGraficaAnchorEl)}>
              <TimelineOutlinedIcon />
            </IconButton>
            <IconButton component={Link} to="/status" sx={{ color: "white" }}>
              <MonitorHeartOutlinedIcon />
            </IconButton>
          </>
        ) : (
          <>
            <Button
              sx={{
                color: "white",
                fontWeight: "600",             // Añadido
                fontSize: "14px",              // Añadido
                textTransform: "none",         // Corregido: antes decía `"white"` (error)
                marginLeft: 1,
              }} startIcon={<HomeOutlinedIcon sx={{ color: "white" }} />} component={Link} to="/">
              DASHBOARD
            </Button>
            <Button sx={{
                color: "white",
                fontWeight: "600",             // Añadido
                fontSize: "14px",              // Añadido
                textTransform: "none",         // Corregido: antes decía `"white"` (error)
                marginLeft: 1,
              }} startIcon={<StorageIcon sx={{ color: "white" }} />} onClick={handleMenuOpen(setConsultaAnchorEl)}>
              CONSULTA
            </Button>
            <Button sx={{
                color: "white",
                fontWeight: "600",             // Añadido
                fontSize: "14px",              // Añadido
                textTransform: "none",         // Corregido: antes decía `"white"` (error)
                marginLeft: 1,
              }} startIcon={<TimelineOutlinedIcon sx={{ color: "white" }} />} onClick={handleMenuOpen(setGraficaAnchorEl)}>
              GRAFICA
            </Button>
            <Button
              sx={{
                color: "white",
                fontWeight: "600",
                fontSize: "14px",
                textTransform: "none",
                marginLeft: 1,
              }}
              startIcon={<MonitorHeartOutlinedIcon sx={{ color: "white" }} />}
              component={Link}
              to="/status"
            >
              STATUS MAQUINA
            </Button>
          </>
        )}

        {/* Menu for Consulta */}
        <Menu
          anchorEl={consultaAnchorEl}
          open={Boolean(consultaAnchorEl)}
          onClose={handleMenuClose(setConsultaAnchorEl)}
          PaperProps={{
            style: {
              maxHeight: '80vh',
              width: '270px',
              borderRadius: '10px',              // 🎯 Bordes redondeados
              padding: '10px 0',                 // 🎯 Espaciado vertical interno
              backgroundColor: "#ffffff",        // 🎯 Fondo blanco
              boxShadow: "0px 4px 20px rgba(0,0,0,0.1)", // 🎯 Sombra suave
            },
          }}
        >
          <Typography
            variant="subtitle1"
            sx={{
              px: 2,
              py: 1,
              fontWeight: 600,
              color: "#771726",              // 🎯 Color vino de tu paleta
              borderBottom: "1px solid #eee"
            }}
          >
            Selecciona una máquina
          </Typography>

          <MenuItem onClick={handleMenuClose(setConsultaAnchorEl)} component={Link} to="/consulta_centrifuga">
            Centrifuga
          </MenuItem>

          <MenuItem onClick={handleMenuClose(setConsultaAnchorEl)} component={Link} to="/consulta_cotherm2comp" >
          CoTherm 2Comp
          </MenuItem>

          <MenuItem onClick={handleMenuClose(setConsultaAnchorEl)} component={Link} to="/consulta_cotherm4comp">
          CoTherm 4Comp
          </MenuItem>

          <MenuItem onClick={handleMenuClose(setConsultaAnchorEl)} component={Link} to="/consulta_cotherm4comp2cc">
          CoTherm 4Comp 2CC
          </MenuItem>

          <MenuItem onClick={handleMenuClose(setConsultaAnchorEl)} component={Link} to="/consulta_ezchiller2comp">
          ezChiller 2Comp
          </MenuItem>

          <MenuItem onClick={handleMenuClose(setConsultaAnchorEl)} component={Link} to="/consulta_ezchiller2compct6">
          ezChiller 2Comp CT6
          </MenuItem>

          <MenuItem onClick={handleMenuClose(setConsultaAnchorEl)} component={Link} to="/consulta_fullservicecooling">
          Full Service Cooling
          </MenuItem>

          <MenuItem onClick={handleMenuClose(setConsultaAnchorEl)} component={Link} to="/consulta_fullservicecooling1comp">
            Full Service Cooling 1Comp
          </MenuItem>

          <MenuItem onClick={handleMenuClose(setConsultaAnchorEl)} component={Link} to="/consulta_fullservicecoolingunico">
          Full Service Cooling UNICO
          </MenuItem>

          <MenuItem onClick={handleMenuClose(setConsultaAnchorEl)} component={Link} to="/consulta_fullservicecoolingv21comp">
            Full Service Cooling V2 1Comp
          </MenuItem>

          <MenuItem onClick={handleMenuClose(setConsultaAnchorEl)} component={Link} to="/consulta_fullservicecoolingv3">
          Full Service Cooling V3
          </MenuItem>

          <MenuItem onClick={handleMenuClose(setConsultaAnchorEl)} component={Link} to="/consulta_fullservicecoolingv31comp">
          Full Service Cooling V3 1Comp
          </MenuItem>

          <MenuItem onClick={handleMenuClose(setConsultaAnchorEl)} component={Link} to="/consulta_licuador1comp">
          Licuador 1Comp
          </MenuItem>

          <MenuItem onClick={handleMenuClose(setConsultaAnchorEl)} component={Link} to="/consulta_optichiller2comp">
          Optichiller 2Comp
          </MenuItem>

          <MenuItem onClick={handleMenuClose(setConsultaAnchorEl)} component={Link} to="/consulta_optichiller2compct6">
          Optichiller 2Comp CT6
          </MenuItem>

          <MenuItem onClick={handleMenuClose(setConsultaAnchorEl)} component={Link} to="/consulta_optichiller1comp">
          Optichiller 1Comp
          </MenuItem>

          <MenuItem onClick={handleMenuClose(setConsultaAnchorEl)} component={Link} to="/consulta_optichiller1compct6">
          Optichiller 1Comp CT6
          </MenuItem>

          <MenuItem onClick={handleMenuClose(setConsultaAnchorEl)} component={Link} to="/consulta_victex1comp">
          Victex 1 Compresor
          </MenuItem>
        </Menu>

        {/* Menu for Grafica */}
        <Menu
          anchorEl={graficaAnchorEl}
          open={Boolean(graficaAnchorEl)}
          onClose={handleMenuClose(setGraficaAnchorEl)}
          PaperProps={{
            style: {
              maxHeight: '80vh',
              width: '270px',
              borderRadius: '10px',              // 🎯 Bordes redondeados
              padding: '10px 0',                 // 🎯 Espaciado vertical interno
              backgroundColor: "#ffffff",        // 🎯 Fondo blanco
              boxShadow: "0px 4px 20px rgba(0,0,0,0.1)", // 🎯 Sombra suave
            },
          }}
        >
          <Typography
            variant="subtitle1"
            sx={{
              px: 2,
              py: 1,
              fontWeight: 600,
              color: "#771726",              // 🎯 Color vino de tu paleta
              borderBottom: "1px solid #eee"
            }}
          >
            Selecciona una máquina
          </Typography>

          <MenuItem onClick={handleMenuClose(setGraficaAnchorEl)} component={Link} to="/grafica_centrifuga">
            Centrifuga
          </MenuItem>

          <MenuItem onClick={handleMenuClose(setGraficaAnchorEl)} component={Link} to="/grafica_cotherm2comp" >
          CoTherm 2Comp
          </MenuItem>

          <MenuItem onClick={handleMenuClose(setGraficaAnchorEl)} component={Link} to="/grafica_cotherm4comp">
          CoTherm 4Comp
          </MenuItem>

          <MenuItem onClick={handleMenuClose(setGraficaAnchorEl)} component={Link} to="/grafica_cotherm4comp2cc">
          CoTherm 4Comp 2CC
          </MenuItem>

          <MenuItem onClick={handleMenuClose(setGraficaAnchorEl)} component={Link} to="/grafica_ezchiller2comp">
          ezChiller 2Comp
          </MenuItem>

          <MenuItem onClick={handleMenuClose(setGraficaAnchorEl)} component={Link} to="/grafica_ezchiller2compct6">
          ezChiller 2Comp CT6
          </MenuItem>

          <MenuItem onClick={handleMenuClose(setGraficaAnchorEl)} component={Link} to="/grafica_fullservicecooling">
            Full Service Cooling
          </MenuItem>

          <MenuItem onClick={handleMenuClose(setGraficaAnchorEl)} component={Link} to="/grafica_fullservicecooling1comp">
            Full Service Cooling 1Comp
          </MenuItem>

          <MenuItem onClick={handleMenuClose(setGraficaAnchorEl)} component={Link} to="/grafica_fullservicecoolingunico">
            Full Service Cooling UNICO
          </MenuItem>

          <MenuItem onClick={handleMenuClose(setGraficaAnchorEl)} component={Link} to="/grafica_fullservicecoolingv21comp">
            Full Service Cooling V2 1Comp
          </MenuItem>

          <MenuItem onClick={handleMenuClose(setGraficaAnchorEl)} component={Link} to="/grafica_fullservicecoolingv3">
            Full Service Cooling V3
          </MenuItem>

          <MenuItem onClick={handleMenuClose(setGraficaAnchorEl)} component={Link} to="/grafica_fullservicecoolingv31comp">
            Full Service Cooling V3 1Comp
          </MenuItem>

          <MenuItem onClick={handleMenuClose(setGraficaAnchorEl)} component={Link} to="/grafica_licuador1comp">
          Licuador 1Comp
          </MenuItem>

          <MenuItem onClick={handleMenuClose(setGraficaAnchorEl)} component={Link} to="/grafica_optichiller2comp">
          Optichiller 2Comp
          </MenuItem>

          <MenuItem onClick={handleMenuClose(setGraficaAnchorEl)} component={Link} to="/grafica_optichiller2compct6">
          Optichiller 2Comp CT6
          </MenuItem>

          <MenuItem onClick={handleMenuClose(setGraficaAnchorEl)} component={Link} to="/grafica_optichiller1comp">
          Optichiller 1Comp
          </MenuItem>

          <MenuItem onClick={handleMenuClose(setGraficaAnchorEl)} component={Link} to="/grafica_optichiller1compct6">
          Optichiller 1Comp CT6
          </MenuItem>

          <MenuItem onClick={handleMenuClose(setGraficaAnchorEl)} component={Link} to="/grafica_victex1comp">
          Victex 1 Compresor
          </MenuItem>
        </Menu>

        {/* Profile Icon and Menu */}
          <Box display="flex" alignItems="center" marginLeft="auto">
            {/* Icono del Usuario */}
            <IconButton color="black" onClick={handleMenuOpen(setProfileAnchorEl)}>
              <PersonIcon sx={{ color: "white" }} />
            </IconButton>
            <Menu
              anchorEl={profileAnchorEl}
              open={Boolean(profileAnchorEl)}
              onClose={handleMenuClose(setProfileAnchorEl)}
              PaperProps={{
                style: {
                  maxHeight: '70vh',
                  width: '250px',
                },
              }}
            >
              {/* Información del Perfil */}
              <Box display="flex" alignItems="center" px={2} py={1}>
                <img
                  src={profileImage}
                  alt="profile-user"
                  style={{ width: 30, height: 30, marginRight: 10 }}
                />
                <Box>
                <Typography
                    variant="body1"
                    sx={{ color: colors.grey[100], fontWeight: "bold" }}
                  >
                    {fullname}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ color: "#771726", fontWeight: 600 }}
                  >
                    {depa}
                  </Typography>
                </Box>
              </Box>
            </Menu>

            {/* Settings Icon and Logout Menu */}
            <IconButton color="white" onClick={handleMenuOpen(setSettingsAnchorEl)}>
              <SettingsIcon sx={{ color: "white" }} />
            </IconButton>
            <Menu
              anchorEl={settingsAnchorEl}
              open={Boolean(settingsAnchorEl)}
              onClose={handleMenuClose(setSettingsAnchorEl)}
            >
              {/* Botón de Logout */}
              <MenuItem
                onClick={handleLogout}
                sx={{
                  color: "#333",               // Texto negro
                  fontWeight: "600",           // Negrita para destacar
                  fontSize: "14px",            // Tamaño cómodo
                }}
              >
                <LogoutIcon sx={{ marginRight: "10px" }} />
                Logout
              </MenuItem>
            </Menu>
          </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Topbar;























